// Questionnaire total footer for the calendar sidebar "phone" preview.
// Copy of the workouts module's QuestionnaireTotal, but the total is computed locally from
// the questions' responses (the workouts module reads it from its own redux state).
import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

import { BoxShadow } from '../../../../shared/GlobalStyles';

const Container = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
  border-radius: 12px;
  padding: 5px;
  box-shadow: ${BoxShadow};
  background: #0dcc8a;
  color: white;
  position: absolute;
  bottom: -15px;
  z-index: 1;
  height: 30px;
`;

const QuestionnaireTotalDiv = styled('div')`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  font-family: 'Nunito Sans';
  font-weight: 500;
`;

// Mirrors the QTCopy logic in the workouts module's Question.js: sum the numerical weight of
// multiple-choice/yes-no answers, and any numeric question value.
const computeTotal = (questions = []) => {
  let total = 0;
  questions.forEach((questionOb) => {
    if (questionOb.inputType === 'MULTIPLE-CHOICE' || questionOb.inputType === 'YES-NO') {
      total += parseInt(questionOb.response?.numericalWeight || 0, 10);
    }
    if (parseInt(questionOb.value, 10)) {
      total += parseInt(questionOb.value, 10);
    }
  });
  return total;
};

const CalendarQuestionnaireTotal = ({ workoutObject }) => (
  <Container>
    <QuestionnaireTotalDiv>
      Total:
      {' '}
      {computeTotal(workoutObject.questions)}
    </QuestionnaireTotalDiv>
  </Container>
);

CalendarQuestionnaireTotal.propTypes = {
  workoutObject: PropTypes.instanceOf(Object).isRequired,
};

export default CalendarQuestionnaireTotal;
